<div class="layout-wrapper">
  <!-- Top Bar -->
  <p-menubar class="layout-topbar">
    <ng-template pTemplate="start">
      <p-button icon="pi pi-bars" [text]="true" (click)="toggleSidebar()"></p-button>
      <img [src]="logoPath" class="app-logo mr-1" />
      <span class="font-bold">Total Asset Management System</span>
    </ng-template>
    <ng-template pTemplate="end">
      <p-button [icon]="isDarkMode() ? 'pi pi-sun' : 'pi pi-moon'" [text]="true" (click)="toggleDarkMode()"
        [pTooltip]="isDarkMode() ? 'Switch to Light Mode' : 'Switch to Dark Mode'" tooltipPosition="bottom"
        styleClass="mr-2"></p-button>
      <p-menu #menu [popup]="true" [model]="userMenuItems"></p-menu>
      <button pButton type="button" (click)="menu.toggle($event)" class="p-button-text">
        <i class="pi pi-user mr-2"></i>
        {{ username }}
        <i class="pi pi-angle-down ml-2"></i>
      </button>
    </ng-template>
  </p-menubar>

  <!-- Main Content -->
  <div class="flex">
    <div class="sidebar" [ngClass]="{'sidebar-collapsed': !sidebarVisible}">
      <p-panelMenu [model]="sidebarMenuItems" [multiple]="true" styleClass="w-full border-none">
      </p-panelMenu>
    </div>
    <div class="content-area">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

<app-user-edit-dialog [(visible)]="profileDialogVisible" [user]="currentUser() || null" [loading]="savingProfile()"
  (save)="onProfileSave($event)" (cancel)="closeProfileDialog()" [isAdminMode]="false">
</app-user-edit-dialog>